module.exports = __webpack_public_path__ + "static/media/stopwatch.046bb8a5.svg";